/*
  Custom icon dismiss button for toasts. Passed as a render prop in Toastify's
  ToastContainer.
*/

import React from 'react';
import styled from 'styled-components';
import Close from "../../../../icons/Close.js";
import Button from "../../../basic/Button/Button.js";
var StyledButton = styled(Button).withConfig({
  componentId: "CL__sc-1yfy03a-0"
})(["vertical-align:top;"]);
var CloseButton = _ref => {
  var {
    closeToast
  } = _ref;
  return /*#__PURE__*/React.createElement(StyledButton, {
    "aria-label": "Dismiss toast",
    icon: Close,
    monochrome: true,
    onClick: closeToast // react-toastify is strict about what this callback can accept and return
    ,
    size: "small",
    variant: "text"
  });
};
export default CloseButton;